import '@styles/app.css';
import { mountIslands, observeIslands } from '@scripts/islands/index.jsx';

document.documentElement.classList.add('js');

function setupFilterChipGroups() {
  const groups = document.querySelectorAll('[data-filter-chip-group]');

  groups.forEach((group) => {
    const chips = group.querySelectorAll('[data-filter-chip]');

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        chips.forEach((item) => {
          item.classList.remove('active');
          item.setAttribute('aria-pressed', 'false');
        });

        chip.classList.add('active');
        chip.setAttribute('aria-pressed', 'true');
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  mountIslands();
  observeIslands();
  setupFilterChipGroups();
});
